module.exports = new __parcel__URL__("army_tab_inactive.a88cca8c.png").toString();